import { Currency } from '../enm/Currency';
import { Country } from '../enm/Country';
import { BusinessSize } from '../enm/BusinessSize';
// Tier thresholds in SEK
const TIERS = {
    [BusinessSize.SMALL]: { to: BusinessSize.MEDIUM },
    [BusinessSize.MEDIUM]: { from: BusinessSize.MEDIUM, to: BusinessSize.LARGE },
    [BusinessSize.LARGE]: { from: BusinessSize.LARGE },
};
const CONVERSION_RATE = {
    [Currency.AUD]: 0.14,
    [Currency.CAD]: 0.13,
    [Currency.CZK]: 2.15,
    [Currency.DKK]: 0.67,
    [Currency.EUR]: 0.089,
    [Currency.NZD]: 0.15,
    [Currency.NOK]: 0.95,
    [Currency.PLN]: 0.42,
    [Currency.SEK]: 1,
    [Currency.CHF]: 0.089,
    [Currency.GBP]: 0.078,
    [Currency.USD]: 0.096,
};
const COUNTRY_CURRENCY = {
    [Country.AU]: Currency.AUD,
    [Country.AT]: Currency.EUR,
    [Country.BE]: Currency.EUR,
    [Country.CA]: Currency.CAD,
    [Country.CZ]: Currency.CZK,
    [Country.DK]: Currency.DKK,
    [Country.FI]: Currency.EUR,
    [Country.FR]: Currency.EUR,
    [Country.DE]: Currency.EUR,
    [Country.GR]: Currency.EUR,
    [Country.IE]: Currency.EUR,
    [Country.IT]: Currency.EUR,
    [Country.NL]: Currency.EUR,
    [Country.NZ]: Currency.NZD,
    [Country.NO]: Currency.NOK,
    [Country.PL]: Currency.PLN,
    [Country.PT]: Currency.EUR,
    [Country.ES]: Currency.EUR,
    [Country.SE]: Currency.SEK,
    [Country.CH]: Currency.CHF,
    [Country.GB]: Currency.GBP,
    [Country.US]: Currency.USD,
};
export const businessSizeConfig = (payload) => {
    var _a;
    const country = ((_a = payload === null || payload === void 0 ? void 0 : payload.business_information) === null || _a === void 0 ? void 0 : _a.registration_country) || Country.SE;
    const currency = COUNTRY_CURRENCY[country] || Currency.SEK;
    const rate = CONVERSION_RATE[currency] || 1;
    return { currency, rate, tiers: TIERS };
};
